import _ from "lodash";
import {FilePond, FilePondErrorDescription, FilePondFile} from "filepond";

/*
* GENERAL
* */

export const handleReadBase64 = async (file: unknown): Promise<(string | ArrayBuffer)> => {
    try {
        return await readUploadedFileAsURL(file);
    } catch (e) {
        return 'Error'
    }
};

const readUploadedFileAsURL = (inputFile: any): Promise<string | ArrayBuffer> => {
    const temporaryFileReader: FileReader = new FileReader();

    return new Promise((resolve, reject) => {
        temporaryFileReader.onerror = () => {
            temporaryFileReader.abort();
            reject('error');
        };

        temporaryFileReader.onload = () => {
            resolve(temporaryFileReader.result);
        };

        temporaryFileReader.readAsDataURL(inputFile);
    });
}

export const sanitizeString = (str: string): string => {
    console.log(`@@@@@ cleaning filename filepond ${str}`);

    //Old cleaner
    str = str.replace(/[^a-z0-9ÁÉÍÓÚÑÇÀÈÌÒÙáéíóúñüçàèìòù\.,_-]/gim, '');
    str = str.replace(/[&\/\\#,+()$~%.'":*¿?¡!<>{}]/gim, '');
    //New cleaner
    str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    str = str.normalize("NFD").replace(/\p{Diacritic}/gu, "");

    console.log(`@@@@@ cleaned filename filepond ${str}`);
    return str.trim();
};

export const onHandleInit = (onInit: (args: any) => void, pond: FilePond): boolean => {
    console.log('onHandleInit', pond);
    // llamada metodo parent si existiera
    if (onInit)
        onInit(pond);

    //console.log('FilePond instance has initialised', this.pond);
    return true;
};

export const fixUploaderTextOnFinish = (id: string | number | any): void => {
    const element = document.getElementById(`filepond--item-${id}`).getElementsByClassName("filepond--file-status")[0];
    element.classList.remove("filepond--file-status-main");
    element.classList.add('filepond--file-status-completed');
};

// @typescript-eslint/explicit-module-boundary-types
export const setCustomMsg = (error: FilePondErrorDescription, id: string | number | any): void => {
    const element = document.getElementById(`filepond--item-${id}`).getElementsByClassName("filepond--file-status-main")[0];
    element.innerHTML = error.body;
}

/*
* FILEPOND
* */

export const onCheckIfQueueHasErrors = (fileItems: FilePondFile[]): boolean => {
    const hasErrors = _.find(fileItems, function (item) {
        return item.status === 8;
    });

    return hasErrors !== undefined;
};

const onCheckIfQueueCompleted = (pond: FilePond) => {
    const files: Array<any> = (pond.getFiles());

    return files.every(file => {
        return file.status === 5; // 5 = completed
    });
};

export const onCheckIfCanUpload = (pond: FilePond, files: any[], filesHasError: boolean, isProcessingFiles: boolean): boolean => {
    return (files.length > 0 && !filesHasError && !isProcessingFiles && !onCheckIfQueueCompleted(pond));
};

export const onCheckIfCanClearList = (files: any[], isProcessingFiles: boolean): boolean => {
    return (files.length > 0 && !isProcessingFiles);
};

export const onHandleUpload = (pond: FilePond): boolean => {
    if (!onCheckIfQueueCompleted(pond)) {
        pond.processFiles();
        return true
    }
    return false;
};

export const onClearFileList = (pond: FilePond): any => {
    // remove all files
    pond.removeFiles();

    const files: Array<any> = [];

    return {
        files,
        isProcessingFiles: false,
        filesHasError: false
    }
};
